import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FullBox, Typography } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import styles from './AllSetPage.module.scss';
const NoPermissionsRelationshipApproved = ()=>/*#__PURE__*/ _jsx(FullBox, {
        centered: true,
        testId: "reviewer-all-set",
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.reviewerInner,
            children: [
                /*#__PURE__*/ _jsx(AnchorLogo, {
                    height: 44
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h3",
                    weight: "normal",
                    children: "This proposal has already been signed"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    children: "If you would like to join this Anchor account, we recommend contacting the account owner."
                })
            ]
        })
    });
export default NoPermissionsRelationshipApproved;
